module.exports = __webpack_public_path__ + "media/25.9090ab91.mp3";